/* Angela Rozas - textos sueltos adicionales al ingles (complementa ar-i18n-en.js). Solo con html lang="en". */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;
  var M = {
    'ver producto': 'View product',
    'novedades': 'New Arrivals',
    'vestidos': 'Dresses',
    'blusas': 'Blouses',
    'accesorios': 'Accessories',
    'pantalones & conjuntos': 'Trousers & Sets',
    'pantalones y conjuntos': 'Trousers & Sets',
    'abrigos & jerséis': 'Coats & Sweaters',
    'abrigos y jerséis': 'Coats & Sweaters',
    'calzado mujer': "Women's Footwear",
    'más vendidos': 'Best Sellers',
    'impuestos incluidos. los': 'Tax included. The',
    'impuestos incluidos.': 'Tax included.',
    'impuestos incluidos': 'Tax included',
    'talla del calzado': 'Shoe size',
    'talla del calzado :': 'Shoe size :',
    'negro': 'Black',
    'marrón': 'Brown'
  };
  var TOK = /(Talla del calzado|Negro|Marrón)(?![A-Za-zÁÉÍÓÚáéíóúñÑ])/gi;
  var TOKMAP = { 'talla del calzado': 'Shoe size', 'negro': 'Black', 'marrón': 'Brown' };
  function tr(s) {
    if (!s) return s;
    var t = s.replace(/\s+/g, ' ').trim();
    if (!t) return s;
    var k = t.toLowerCase();
    var out = null;
    if (Object.prototype.hasOwnProperty.call(M, k)) out = M[k];
    else if (t.length <= 40 && /(talla del calzado|negro|marrón)/i.test(t)) {
      out = t.replace(TOK, function (m) { return TOKMAP[m.toLowerCase()]; });
      if (out === t) out = null;
    }
    if (out === null) return s;
    return s.match(/^\s*/)[0] + out + s.match(/\s*$/)[0];
  }
  var ATTRS = ['aria-label', 'title', 'alt'];
  function doText(n) { var v = n.nodeValue, r = tr(v); if (r !== v) n.nodeValue = r; }
  function doEl(el) {
    if (el.nodeType !== 1) return;
    var tg = el.tagName;
    if (tg === 'SCRIPT' || tg === 'STYLE' || tg === 'NOSCRIPT') return;
    for (var i = 0; i < ATTRS.length; i++) {
      if (!el.hasAttribute(ATTRS[i])) continue;
      var o = el.getAttribute(ATTRS[i]), r = tr(o);
      if (r !== o) el.setAttribute(ATTRS[i], r);
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1) return;
    doEl(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) {
        var p = n.parentNode;
        if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE' || p.tagName === 'NOSCRIPT')) continue;
        doText(n);
      } else doEl(n);
    }
  }
  function run() {
    walk(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') doText(m.target);
        else if (m.type === 'attributes') doEl(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  if (document.body) run(); else document.addEventListener('DOMContentLoaded', run);
})();
